import { CSSProperties } from 'react';
import { Skeleton } from '@material-ui/lab';
import { CustomLogo } from './CustomLogo';
import { DefaultLogo } from './DefaultLogo';
import IconLogo from './IconLogo';
import { useLogos } from './hooks/useLogos';

type LogoProps = {
  full?: boolean;
  style?: CSSProperties;
  hidePoweredBy?: boolean;
};

export const Logo = ({
  full = true,
  style,
  hidePoweredBy = false,
}: LogoProps) => {
  const { data: logos, isLoading } = useLogos();

  if (isLoading) {
    return (
      <Skeleton style={{ minWidth: '190px' }} width="100%" height="100%" />
    );
  }

  if (!full) {
    return <IconLogo customIconLogo={logos?.iconLogo} style={style} />;
  }

  return logos?.fullLogo ? (
    <CustomLogo customLogo={logos.fullLogo} hidePoweredBy={hidePoweredBy} />
  ) : (
    <DefaultLogo style={style} />
  );
};
